<app-topheader></app-topheader>

<div class="scrollingcontainer container">
    
    <app-fancy-page-title topTitle="POINTS OF INTEREST"></app-fancy-page-title>   

    <div class="pagemask" *ngIf="pagemask == true">This page is only available during your cruise.</div>

    <div *ngIf="loadError" class="comingsoonmessage">
        Unable to load Points of Interest. <button type="button" class="retry-button" (click)="loadData()">Try again</button>
    </div>
    
    <div *ngIf="pagemask == false && !loadError">

        <div *ngIf="statusR == true">
            <div class="onlycomingsoonmessage">Coming Soon</div>

            <div class="center">
                <span *ngIf="ShipCoordData?.riverpos!=null" class="currentmileage">Current Location:</span>
                <span *ngIf="ShipCoordData?.riverpos!=null" class="currentmilemarker"> {{ShipCoordData?.riverpos}}</span>
                <span *ngIf="ShipCoordData?.riverpos!=null" (click)="loadData()"> <i class="fa-solid fa-rotate-right"></i></span>
                <span *ngIf="ShipCoordData?.riverpos==null" (click)="loadData()" class="currentmileage">Refresh&nbsp;<i class="fa-solid fa-rotate-right"></i></span>
            </div>
        
            <hr class="goldbar">
        </div>

        <div *ngIf="statusR == false">
       
            <div class="centeralign center">
                <span class="nearbypointsofinterestheader">Nearby</span>
                <span class="toggleright"><mat-slide-toggle name="viewallpois" [(ngModel)]="viewallpointsofinterest">View More</mat-slide-toggle></span>
            </div>
        
            <div class="center">
                <span *ngIf="ShipCoordData?.riverpos!=null" class="currentmileage">Current Location:</span>
                <span *ngIf="ShipCoordData?.riverpos!=null" class="currentmilemarker"> {{ShipCoordData?.riverpos}}</span>
                <span *ngIf="ShipCoordData?.riverpos!=null" (click)="loadData()"> <i class="fa-solid fa-rotate-right"></i></span>
                <span *ngIf="ShipCoordData?.riverpos==null" (click)="loadData()" class="currentmileage">Refresh&nbsp;<i class="fa-solid fa-rotate-right"></i></span>
            </div>
        
            <hr class="goldbar">
        
            <div class="pointsofinterestheader">Nearby Points of Interest</div>

            <!-- NEARBY POINTS OF INTEREST (always shown) -->
            <div class="pointsofinterest" *ngFor="let poi of nearbypointsofinterest; trackBy: trackByPoi">
                <div class="listofpointsofinterest">
                    <app-poi-item [poi]="poi" [showDistance]="true"></app-poi-item>
                </div>
            </div>

            <!-- VISIBLE POINTS OF INTEREST (shown when View More is toggled, same list) -->
            <ng-container *ngIf="viewallpointsofinterest">
                <div class="pointsofinterest" *ngFor="let poi of visiblepointsofinterest; trackBy: trackByPoi">
                    <div class="listofpointsofinterest">
                        <app-poi-item [poi]="poi" [showDistance]="true"></app-poi-item>
                    </div>
                </div>
            </ng-container>

            <div *ngIf="nearbypointsofinterest.length === 0 && (!viewallpointsofinterest || visiblepointsofinterest.length === 0)">
                <div class="comingsoonmessage">Coming Soon</div>
            </div>

            <!-- INTEREST TOPICS -->
            <hr class="goldbar">
    
            <div class="pointsofinterestheader">General Interest Topics</div> 

            <div *ngIf="interesttopics.length === 0">
                <div class="comingsoonmessage">Coming Soon</div>
            </div>

            <div class="pointsofinterest" *ngFor="let poi of interesttopics; trackBy: trackByPoi">
                <div class="listofpointsofinterest">
                    <app-poi-item [poi]="poi" [showDistance]="false"></app-poi-item>
                </div>
            </div>
        
        </div>
        
    </div>

</div>

<app-bottommenu></app-bottommenu>
